/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  DatePicker,
  Radio,
  Input,
  Button,
  message,
  Select,
  Modal,
  Spin,
  Form,
} from "antd";
import dayjs from "dayjs";
// import { postRequest } from "../Auth/api";
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import "./../style/cart.css";
import axios from "axios";
import { useCart } from "../context/CartContext";
import SquareCardPayment from "../Payment/SquareCardPayment";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import { SearchOutlined } from "@ant-design/icons";
// import { useCart } from "../context/CartContext";


dayjs.extend(utc);
dayjs.extend(timezone);

const CartPage = () => {
  // const [cartItems, setCartItems] = useState([]);
  const [deliveryType, setDeliveryType] = useState("D");
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  // const [address1, setAddress1] = useState("");
  // const [address2, setAddress2] = useState("");
  const [coupon, setCoupon] = useState("");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingpayment, setLoadingpayment] = useState(false);
  const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false);
  // const [createdOrderId, setCreatedOrderId] = useState(null);
  const navigate = useNavigate();
  const { setCartCount } = useCart();
  const { cartItems, setCartItems, clearCart } = useCart();
  const [showQuickRegister, setShowQuickRegister] = useState(false);
  const [quickName, setQuickName] = useState("");
  const [quickEmail, setQuickEmail] = useState("");
  const [quickPhone, setQuickPhone] = useState("");
  const [quickAddress1, setQuickAddress1] = useState("");
  const [quickAddress2, setQuickAddress2] = useState("");
  const [quickRegisterLoading, setQuickRegisterLoading] = useState(false);

  const [autocomplete, setAutocomplete] = useState(null);
  const [distanceError, setDistanceError] = useState("");

  // const [pendingOrderPayload, setPendingOrderPayload] = useState(null);

  const UserId = localStorage.getItem("UserId");
  const [form] = Form.useForm();
  console.log(setNotes, setLoading);


//   useEffect(() => {
//   const script = document.createElement("script");
//   script.src = "https://web.squarecdn.com/v1/square.js"; 
//   // script.src = "https://sandbox.web.squarecdn.com/v1/square.js"; 
//   script.async = true;
//   script.defer = true;
//   document.body.appendChild(script);

//   return () => {
//     document.body.removeChild(script);
//   };
// }, []);

  // const fetchCartItems = async () => {
  //   setLoading(true);
  //   try {
  //     const token = localStorage.getItem("token");
  //     const userid = localStorage.getItem("UserId");

  //     const res = await axios.get(
  //       `https://cafemandhurah.mandurahcafe.com.au/api/cart/user/${userid}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     const items = (res.data?.data || []).map((item) => ({
  //       ...item,
  //       quantity: Number(item.quantity) || 1,
  //     }));
  //     console.log("items-->", items.note);
  //     // console.log("item?.item?.note", item?.item?.note)

  //     setCartItems(items); // assuming setCartItems is in your component's state
  //     setCartCount(items.length);
  //   } catch (err) {
  //     const apiMessage =
  //       err.response?.data?.message || "Failed to load cart items";
  //     console.error("Cart fetch error:", err);
  //     message.error(apiMessage);
  //   } finally {
  //     setLoading(false); // Stop spinner
  //   }
  // };

  // useEffect(() => {
  //   fetchCartItems();
  // }, []);

  useEffect(() => {
    const storedQuickUser = localStorage.getItem("quick_user_info");
    if (!storedQuickUser) {
      setShowQuickRegister(true); // show popup only if not saved
    }
  }, []);

  const handleQuickRegister = async () => {
    try {
      setQuickRegisterLoading(true);

      const res = await axios.post(
        "https://cafemandhurah.mandurahcafe.com.au/api/quick-register",
        {
          name: quickName,
          phone: quickPhone,
          email: quickEmail,
          address: quickAddress1,
          address2: quickAddress2,
        }
      );

      localStorage.setItem("quick_user_info", JSON.stringify(res.data));
      localStorage.setItem("quick_user_address1", quickAddress1);
      localStorage.setItem("quick_user_address2", quickAddress2 || "");

      // Call check-delivery API
      // const address1 = localStorage.getItem("quick_user_address1") || "";
      const distance = parseFloat(
        localStorage.getItem("mandurah_delivery_distance") || 0
      );

      // Calculate subtotal from cart items
      const subtotal = cartItems.reduce(
        (sum, item) =>
          sum +
          (parseFloat(item?.locked_price || 0) +
            parseFloat(item?.locked_choice_price || 0)) *
            item.quantity,
        0
      );

      // Call check-delivery API with distance and amount
      const deliveryRes = await axios.post(
        "https://cafemandhurah.mandurahcafe.com.au/api/check-delivery",
        {
          distance: distance,
          amount: subtotal,
        }
      );

      const { delivery_charge } = deliveryRes.data;
      localStorage.setItem("mandurah_delivery_charge", delivery_charge);

      // const { delivery_charge, distance } = deliveryRes.data;

      localStorage.setItem("mandurah_delivery_charge", delivery_charge);
      localStorage.setItem("mandurah_delivery_distance", distance);

      message.success("Personal Details added successful");
      setShowQuickRegister(false);
    } catch (err) {
      console.error("Quick Register Failed:", err);
      message.error("Quick registration failed. Please try again.");
    } finally {
      setQuickRegisterLoading(false);
    }
  };

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const toRad = (value) => (value * Math.PI) / 180;

    const R = 6371; // Radius of Earth in km
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    return distance; // in kilometers
  };

  useEffect(() => {
    const storedAddress1 = localStorage.getItem("quick_user_address1");
    if (storedAddress1) {
      setQuickAddress1(storedAddress1);
    }
  }, []);

  const increment = (item) => {
    const basePrice = parseFloat(item.item.price || 0);
    const choicePrice = Array.isArray(item.item_choices)
      ? item.item_choices.reduce(
          (sum, choice) => sum + parseFloat(choice.price || 0),
          0
        )
      : 0;

    const updated = cartItems.map((ci) => {
      if (ci.id === item.id) {
        const newQty = Number(ci.quantity) + 1;
        return {
          ...ci,
          quantity: newQty,
          locked_price: (basePrice * newQty).toFixed(2),
          locked_choice_price: (choicePrice * newQty).toFixed(2),
        };
      }
      return ci;
    });

    setCartItems(updated);
  };

  const decrement = (item) => {
    const basePrice = parseFloat(item.item.price || 0);
    const choicePrice = Array.isArray(item.item_choices)
      ? item.item_choices.reduce(
          (sum, choice) => sum + parseFloat(choice.price || 0),
          0
        )
      : 0;

    const updated = cartItems.map((ci) => {
      if (ci.id === item.id) {
        const newQty = Math.max(Number(ci.quantity) - 1, 1);
        return {
          ...ci,
          quantity: newQty,
          locked_price: (basePrice * newQty).toFixed(2),
          locked_choice_price: (choicePrice * newQty).toFixed(2),
        };
      }
      return ci;
    });

    setCartItems(updated);
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");

    try {
      if (token) {
        // ✅ If token exists, call backend API
        await axios.delete(
          `https://cafemandhurah.mandurahcafe.com.au/api/cart/hard-delete/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      // ✅ Remove item from state
      const updatedCart = cartItems.filter((item) => item.id !== id);
      setCartItems(updatedCart);

      // ✅ Update localStorage
      localStorage.setItem("cartItems", JSON.stringify(updatedCart));

      // ✅ Update cart count
      setCartCount(updatedCart.length);

      message.success("Item removed from cart");
    } catch (err) {
      console.error("Delete cart item failed:", err);
      message.error("Failed to remove item");
    }
  };

  const getTimeSlots = () => {
    if (!date) return [];

    const selectedDate = dayjs(date).tz("Australia/Perth");
    const today = dayjs().tz("Australia/Perth");
    const isToday = selectedDate.isSame(today, "day");
    const day = selectedDate.day(); // 0 (Sun) to 6 (Sat)

    // Define hours for each day
    const hoursByDay = {
      0: { open: 8, close: 12 }, // Sunday
      1: { open: 6, close: 17 }, // Monday
      2: { open: 6, close: 17 }, // Tuesday
      3: { open: 6, close: 20 }, // Wednesday
      4: { open: 6, close: 20 }, // Thursday
      5: { open: 6, close: 20 }, // Friday
      6: { open: 6, close: 20 }, // Saturday
    };

    const { open, close } = hoursByDay[day];
    let startTime = selectedDate.hour(open).minute(0).second(0);
    const closingTime = selectedDate.hour(close).minute(0).second(0);

    if (isToday) {
      const nowPlusOneHour = today.add(1, "hour").startOf("minute");
      // Round up to next 30 min slot
      const rounded =
        nowPlusOneHour.minute() <= 30
          ? nowPlusOneHour.minute(30)
          : nowPlusOneHour.add(1, "hour").minute(0);
      if (rounded.isAfter(startTime)) {
        startTime = rounded;
      }
    }

    const slots = [];
    let current = startTime;

    while (current.isBefore(closingTime)) {
      slots.push(current);
      current = current.add(30, "minute");
    }

    return slots;
  };

  const calculateTotal = () => {
    const subtotal = cartItems.reduce((sum, item) => {
      const lockedPrice = parseFloat(item?.locked_price || 0);
      const choicePrice = parseFloat(item?.locked_choice_price || 0);
      return sum + lockedPrice + choicePrice;
    }, 0);

    const discount = 0;
    const deliveryCharge =
      deliveryType === "T"
        ? 0
        : parseFloat(localStorage.getItem("mandurah_delivery_charge") || 0);

    const taxes = 0;
    const total = subtotal - discount + deliveryCharge + taxes;

    return { subtotal, discount, deliveryCharge, taxes, total };
  };

const handleCheckout = async () => {
  // ✅ Step 0: Basic validations
  if (!deliveryType) {
    return message.warning("Please select Delivery or Take Away.");
  }

  if (!date) {
    return message.warning("Please select a delivery date.");
  }

  if (!time) {
    return message.warning("Please select a time slot.");
  }

  if (!cartItems.length) {
    return message.warning("Your cart is empty.");
  }

  try {
    setLoadingpayment(true);

    // ✅ Step 1: Retrieve user info
    let userId = null;
    const storedUser = localStorage.getItem("quick_user_info");
    const address1 = localStorage.getItem("quick_user_address1") || "";
    const address2 = localStorage.getItem("quick_user_address2") || "";

    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      userId = parsed?.user?.id;
    }

    // ✅ Step 2: Get delivery charge
    const deliveryCharge =
      deliveryType === "T"
        ? 0
        : parseFloat(localStorage.getItem("mandurah_delivery_charge") || 0);

    // ✅ Step 3: Calculate subtotal
    const subtotal = cartItems.reduce(
      (sum, i) =>
        sum +
        parseFloat(i.locked_price || 0) +
        parseFloat(i.locked_choice_price || 0),
      0
    );

    // ✅ Step 4: Prepare item and choice IDs
    const item_ids = cartItems.map((item) => item.item?.id || item.item_id);
    const choice_ids = cartItems.flatMap((item) =>
      Array.isArray(item.item_choices)
        ? item.item_choices.map((choice) => choice.id)
        : []
    );

    // ✅ Step 5: Build payload
    const payload = {
      user_id: userId,
      total_items: cartItems.length.toString(),
      subtotal_amount: subtotal.toFixed(2),
      discount_amount: "0.00",
      tax_amount: "0.00",
      delivery_time_slot: `${dayjs(date).format("YYYY-MM-DD")} ${dayjs(time).format("HH:mm:ss")}`,
      final_amount: (subtotal + deliveryCharge).toFixed(2), // Include delivery charge
      payment_status: "0",
      order_status: "Pending",
      notes,
      item_ids,
      choice_ids,
      delivery_charge: deliveryCharge.toFixed(2),
      address: `${address1}\n${address2}`,
      order_type: deliveryType,
      mandurah_delivery_charge: deliveryCharge.toFixed(2), // explicitly added for clarity
    };

    // ✅ Step 6: Save payload and redirect to payment page
    localStorage.setItem("pending_order_payload", JSON.stringify(payload));
    navigate("/create-payment-and-order");

  } catch (err) {
    message.error("Checkout failed. Please try again.");
    console.error(err);
  } finally {
    setLoadingpayment(false);
  }
};


  const handleCartClear = async () => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        await axios.delete(
          `https://cafemandhurah.mandurahcafe.com.au/api/cart/clear/${UserId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCartCount(0);
      } catch (err) {
        console.error("Cart clear failed:", err);
      }
    } else {
      localStorage.removeItem("cartItems");
      // localStorage.removeItem("UserId");
      // localStorage.removeItem("token");
      setCartCount(0);
      console.warn("Cart data cleared. Quick register data retained.");
    }
  };

  const { subtotal, discount, deliveryCharge, taxes, total } = calculateTotal();
  return (
    <>
      <BreadcrumbBanner
        title="My Cart"
        backgroundImage="/Images/banner-about.jpg"
      />
      <div className="cart-page">
        <div className="cart-page-wrapper">
          <div className="cart-left">
            <h3>Your Cart</h3>
            <Spin spinning={loading} tip="Loading cart..." className="loading">
              {cartItems.map((item) => (
                <div className="cart-item-card" key={item.id}>
                  <img src={item?.item?.image_url} alt={item?.item?.name} loading="lazy"/>
                  <div className="info">
                    <h4>{item?.item?.name}</h4>

                    {Array.isArray(item.item_choices) &&
                      item.item_choices.map((choice, index) => (
                        <p
                          key={index}
                          style={{
                            margin: "5px 0",
                            fontSize: 13,
                            color: "#B54E20",
                          }}
                        >
                          + {choice.name} ($
                          {parseFloat(choice.price).toFixed(2)})
                        </p>
                      ))}
                    {item?.note && (
                      <p className="card-info-note">
                        <strong>Note: </strong>
                        {item.note}
                      </p>
                    )}

                    <div className="quantity-control">
                      <button onClick={() => decrement(item)}>-</button>
                      <span>{item.quantity || 1}</span>
                      <button onClick={() => increment(item)}>+</button>
                    </div>
                  </div>
                  <div className="cart-total-btn">
                    {(() => {
                      const basePrice = parseFloat(item.locked_price || 0);
                      const choicePrice = parseFloat(
                        item.locked_choice_price || 0
                      );
                      const total = basePrice + choicePrice;
                      return <strong>${total.toFixed(2)}</strong>;
                    })()}

                    <button
                      onClick={() => handleDelete(item.id)}
                      className="cart-delete-btn"
                    >
                      <img src="/Images/delet-icon.png" alt="Delete-icon" loading="lazy"></img>
                    </button>
                  </div>
                </div>
              ))}
              <Button
                className="add-more-btn"
                block
                onClick={() => navigate("/view-our-menu")}
              >
                ADD MORE ITEMS
              </Button>
            </Spin>
          </div>

          <div className="cart-right">
            <Radio.Group
              onChange={(e) => setDeliveryType(e.target.value)}
              value={deliveryType}
              className="order-type"
            >
              <Radio value="D">Delivery</Radio>
              <Radio value="T">Take Away</Radio>
            </Radio.Group>

            {/* <Input
                placeholder="Full Name *"
                style={{ marginTop: 10 }}
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
              <div style={{ display: "flex", gap: "10px", marginTop: 10 }}>
                <Input
                  placeholder="Mobile Number *"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  style={{ flex: 1 }}
                />
                <Input
                  placeholder="Email ID *"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{ flex: 1 }}
                />
              </div> */}

            <div className="cart-date-time">
              <DatePicker
                suffixIcon={<CalendarOutlined style={{ color: "#B54E20" }} />}
                style={{ width: "100%", marginTop: 10 }}
                disabledDate={(current) =>
                  current && current < dayjs().startOf("day")
                }
                onChange={setDate}
              />
              <Select
                placeholder="Select Time Slot"
                disabled={!date}
                suffixIcon={
                  <ClockCircleOutlined style={{ color: "#B54E20" }} />
                }
                style={{ width: "100%", marginTop: 10 }}
                onChange={(value) => setTime(dayjs(value, "HH:mm"))}
                className="time-slot"
              >
                {getTimeSlots().map((slot) => (
                  <Select.Option
                    key={slot.format("HH:mm")}
                    value={slot.format("HH:mm")}
                  >
                    {slot.format("hh:mm A")}
                  </Select.Option>
                ))}
              </Select>
            </div>

            {deliveryType === "D" && (
              <>
                {/* <Form.Item
                  name="address1"
                  rules={[
                    
                  ]}
                >
                  <Input
                    placeholder="Address Line 1 *"
                    className="quick-input"
                    value={quickAddress1}
                    onChange={(e) => setQuickAddress1(e.target.value)}
                  />
                </Form.Item> */}

                {/* <Input
                    placeholder="Address Line 2 (optional)"
                    style={{ marginTop: 10 }}
                    onChange={(e) => setAddress2(e.target.value)}
                  /> */}
              </>
            )}

            <Input
              placeholder="Add Coupon or Gift Card"
              style={{ marginTop: 10 }}
              value={coupon}
              onChange={(e) => setCoupon(e.target.value)}
              addonAfter={<Button type="link">APPLY</Button>}
            />

            <div className="summary">
              <div className="summary-row">
                <span>Sub Total</span>
                <span>${subtotal.toFixed(2)}</span>
              </div>
              <div className="summary-row">
                <span>Taxes</span>
                <span>${taxes.toFixed(2)}</span>
              </div>
              <div className="summary-row">
                <span>Delivery Charges</span>
                <span>${deliveryCharge.toFixed(2)}</span>
              </div>
              <div className="summary-row discount">
                <span>Discount</span>
                <span>-${discount.toFixed(2)}</span>
              </div>
              <hr />
              <div className="summary-row total">
                <span>Total</span>
                <span>${total.toFixed(2)}</span>
              </div>
            </div>

            <Button
              type="primary"
              block
              loading={loadingpayment}
              style={{ marginTop: 10 }}
              onClick={handleCheckout}
              className="proceed-btn"
              id="proceedtocheckouttag"
            >
              PROCEED TO CHECKOUT
            </Button>
          </div>
        </div>

        {/* <Modal
          open={isPaymentModalVisible}
          onCancel={() => setIsPaymentModalVisible(false)}
          footer={null}
          title="Pay with Card"
          centered
          maskClosable={false}
        >
          <SquareCardPayment
            amount={calculateTotal().total}
            orderId={null} // not needed now
            onSuccess={async () => {
              try {
                message.success("Payment and Order Complete");

                await handleCartClear();
                setCartItems([]);
                clearCart();

                localStorage.removeItem("pending_order_payload");
                localStorage.removeItem("quick_user_info");
                localStorage.removeItem("quick_user_address1");
                localStorage.removeItem("quick_user_address2");
                localStorage.removeItem("mandurah_delivery_charge");
                localStorage.removeItem("mandurah_delivery_distance");
                localStorage.removeItem("delivery_distance_km");

                setIsPaymentModalVisible(false);
                navigate("/thank-you");
              } catch (error) {
                console.error("Cleanup after payment failed:", error);
                message.error(
                  "Something went wrong after payment. Please contact support."
                );
              }
            }}
          />
        </Modal> */}

        <Modal
          open={showQuickRegister}
          footer={null}
          centered
          title="Personal Details"
          className="quick-register-modal"
          maskClosable={false}
          closable={false}
          keyboard={false}
        >
          <Spin spinning={quickRegisterLoading}>
            <Form
              layout="vertical"
              form={form}
              onFinish={handleQuickRegister}
              initialValues={{
                fullName: quickName,
                phone: quickPhone,
                email: quickEmail,
                address1: quickAddress1,
                address2: quickAddress2,
              }}
            >
              <Form.Item
                name="fullName"
                rules={[{ required: true, message: "Full Name is required" }]}
              >
                <Input
                  placeholder="Full Name *"
                  className="quick-input"
                  onChange={(e) => setQuickName(e.target.value)}
                />
              </Form.Item>

              <div className="quick-input-row">
                <Form.Item
                  name="phone"
                  rules={[
                    { required: true, message: "Mobile Number is required" },
                    {
                      pattern: /^[0-9]{10,15}$/,
                      message: "Enter valid mobile number",
                    },
                  ]}
                  style={{ flex: 1, marginRight: 8 }}
                >
                  <Input
                    placeholder="Mobile Number *"
                    className="quick-input"
                    onChange={(e) => setQuickPhone(e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: "Email is required" },
                    {
                      type: "email",
                      message: "Enter a valid email address",
                    },
                  ]}
                  style={{ flex: 1 }}
                >
                  <Input
                    placeholder="Email Id *"
                    className="quick-input"
                    onChange={(e) => setQuickEmail(e.target.value)}
                  />
                </Form.Item>
              </div>
              <Form.Item
                name="address1"
                validateStatus={distanceError ? "error" : ""}
                help={distanceError || ""}
                rules={[
                  { required: true, message: "Address Line 1 is required" },
                ]}
              >
                <LoadScript
                  googleMapsApiKey="AIzaSyAb9QZYwLTQNKnj7PFEAu7p-xUYU153I40"
                  libraries={["places"]}
                >
                  <Autocomplete
                    onLoad={(autocomplete) => setAutocomplete(autocomplete)}
                    onPlaceChanged={() => {
                      if (autocomplete !== null) {
                        const place = autocomplete.getPlace();
                        const formatted = place.formatted_address;
                        const location = place.geometry?.location;

                        if (location) {
                          const lat = location.lat();
                          const lng = location.lng();

                          const mandurahLat = -32.5309393653685;
                          const mandurahLng = 115.72191490351278;

                          const distance = calculateDistance(
                            mandurahLat,
                            mandurahLng,
                            lat,
                            lng
                          );

                          if (distance > 20) {
                            setDistanceError(
                              "Sorry, We not able to delivery at this location"
                            );
                            setQuickAddress1(""); // optional
                            form.setFieldsValue({ address1: "" });
                            localStorage.removeItem("delivery_distance_km");
                          } else {
                            setDistanceError("");
                            setQuickAddress1(formatted);
                            form.setFieldsValue({ address1: formatted });
                            localStorage.setItem(
                              "delivery_distance_km",
                              distance.toFixed(2)
                            );
                          }
                        }
                      }
                    }}
                    options={{
                      types: ["address"],
                      componentRestrictions: { country: "au" },
                    }}
                  >
                    <Input
                      placeholder="Address Line 1 *"
                      className="quick-input"
                      value={quickAddress1}
                      onChange={(e) => {
                        setQuickAddress1(e.target.value);
                        setDistanceError(""); // reset error on change
                      }}
                       prefix={<SearchOutlined style={{ color: "#aaa" }} />}
                    />
                  </Autocomplete>
                </LoadScript>
              </Form.Item>

              <Form.Item name="address2">
                <Input
                  placeholder="Address Line 2"
                  className="quick-input"
                  onChange={(e) => setQuickAddress2(e.target.value)}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  htmlType="submit"
                  block
                  className="quick-submit-btn"
                  type="primary"
                >
                  SUBMIT
                </Button>
              </Form.Item>
            </Form>
          </Spin>
        </Modal>
      </div>
    </>
  );
};

export default CartPage;
